import React, { useMemo, useState } from 'react';
import { App, Card, Select, Table } from 'antd';
import { _T } from '../../../../../base-react/src/Localization';
import { apis, hooks, models } from '@vote4dance/judging-sdk';
var Stream = hooks.streams.Stream;
var ClassItem = models.classes.ClassItem;
var ClassesSource = models.classes.ClassesSource;
var JudgingPanelSource = models.judges.JudgingPanelSource;
var Api = apis.Api;
const ClassPanelAssignments = ({ competition_id, disabled }) => {
    const { notification } = App.useApp();
    const [classes, loadingClasses] = Stream(ClassesSource(competition_id));
    const panelSource = useMemo(() => JudgingPanelSource(competition_id), [competition_id]);
    const [panels, loadingPanels] = Stream(panelSource);
    const [panelSaves, setPanelSaves] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const panelOptions = useMemo(() => {
        return (panels !== null && panels !== void 0 ? panels : [])
            .filter((panel) => panel.panel_id)
            .map((panel) => ({
            label: panel.panel_name || panel.panel_id,
            value: panel.panel_id
        }));
    }, [panels]);
    const handleClassPanelChange = async (cls, panel_id) => {
        var _a;
        const class_id = cls === null || cls === void 0 ? void 0 : cls.class_id;
        if (!class_id) {
            return;
        }
        setPanelSaves(prev => ({ ...prev, [class_id]: true }));
        try {
            await Api.update(`${ClassesSource(competition_id).url}/${class_id}`, {
                ...cls,
                default_panel_id: panel_id !== null && panel_id !== void 0 ? panel_id : null
            });
        }
        catch (error) {
            notification.error({
                message: _T(((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.message) || (error === null || error === void 0 ? void 0 : error.message) || 'common.error')
            });
        }
        finally {
            setPanelSaves(prev => {
                const next = { ...prev };
                delete next[class_id];
                return next;
            });
        }
    };
    const rows = useMemo(() => {
        return (classes || []).map(cls => {
            var _a, _b;
            const assignedPanelId = (_a = cls.default_panel_id) !== null && _a !== void 0 ? _a : null;
            return {
                key: (_b = cls.class_id) !== null && _b !== void 0 ? _b : '',
                class_id: cls.class_id,
                classLabel: ClassItem.getClassLabel(cls),
                floor_names: cls.floor_names,
                classItem: cls,
                assignedPanelId
            };
        });
    }, [classes]);
    const applyPanelToRows = async (targetRows, panel_id) => {
        var _a, _b;
        for (const targetRow of targetRows) {
            if (!targetRow.classItem) {
                continue;
            }
            const hasResults = Number((_b = (_a = targetRow.classItem) === null || _a === void 0 ? void 0 : _a.panel_locked) !== null && _b !== void 0 ? _b : 0) > 0;
            if (hasResults) {
                continue;
            }
            await handleClassPanelChange(targetRow.classItem, panel_id);
        }
    };
    const hasFloors = rows === null || rows === void 0 ? void 0 : rows.some(cls => cls.floor_names !== null);
    const columns = [
        {
            title: _T('class.title'),
            dataIndex: 'classLabel',
            key: 'classLabel',
            render: (text) => text
        },
        hasFloors ? {
            title: _T('floor.details.floor_name.label'),
            dataIndex: 'floor_names',
            responsive: ['md'],
        } : {},
        {
            title: _T('panel.title'),
            key: 'assignPanel',
            render: (_, row) => {
                var _a, _b, _c;
                if (!row.class_id) {
                    return null;
                }
                const hasResults = Number((_b = (_a = row.classItem) === null || _a === void 0 ? void 0 : _a.panel_locked) !== null && _b !== void 0 ? _b : 0) > 0;
                return (React.createElement(Select, { showSearch: true, optionFilterProp: "label", filterOption: (input, option) => { var _a, _b; return (_b = ((_a = option === null || option === void 0 ? void 0 : option.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(input.toLowerCase()))) !== null && _b !== void 0 ? _b : false; }, allowClear: true, options: panelOptions, placeholder: _T('common.select', { name: _T('panel.title').toLowerCase() }), value: (_c = row.assignedPanelId) !== null && _c !== void 0 ? _c : undefined, loading: !!panelSaves[row.class_id], disabled: disabled || panelOptions.length === 0 || loadingPanels || hasResults, onChange: (value) => {
                        const panelValue = value;
                        let targetRows = selectedRows.length > 0 ? selectedRows : [row];
                        targetRows = targetRows.filter(r => { var _a, _b; return Number((_b = (_a = r.classItem) === null || _a === void 0 ? void 0 : _a.panel_locked) !== null && _b !== void 0 ? _b : 0) === 0; });
                        if (targetRows.length === 0 && !hasResults) {
                            targetRows = [row];
                        }
                        if (targetRows.length === 0) {
                            return;
                        }
                        void applyPanelToRows(targetRows, panelValue);
                    }, style: { minWidth: 180 } }));
            }
        }
    ].filter(col => Object.keys(col).length > 0);
    return (React.createElement(Card, { title: _T('class.plural'), variant: "outlined" },
        React.createElement(Table, { columns: columns, dataSource: rows, rowKey: "key", pagination: false, size: "small", loading: loadingClasses, rowSelection: {
                selectedRowKeys,
                onChange: (keys, rows) => {
                    setSelectedRowKeys(keys);
                    setSelectedRows(rows);
                },
                getCheckboxProps: (row) => {
                    var _a, _b;
                    return ({
                        disabled: Number((_b = (_a = row.classItem) === null || _a === void 0 ? void 0 : _a.panel_locked) !== null && _b !== void 0 ? _b : 0) > 0
                    });
                }
            } })));
};
export { ClassPanelAssignments };
